import nlp from 'wink-nlp'
import model from 'wink-eng-lite-web-model'

export const winkNLP = nlp(model)
